import { apiStart, apiSuccess } from "./apiActions";
import { catchHandler, errorHandler, successHandler } from "./responseHandler";
import axios from "axios";
import {
  DELETE_NOTIFICATIONS,
  GET_NOTIFICATIONS_INFO,
  HANDLE_PCP_REQUEST,
  UPDATE_NOTIFICATIONS_STATUS,
  UPDATE_NOTIFICATION_STATE,
} from "./actionTypes";

import api from "../../services";

import {
  getNotificationsUrl,
  updateNotificationStatusUrl,
  deleteNotificationUrl,
  updatePCPStatusUrl,
} from "../../utils/urls";
import { updateUserData } from "../../utils/localStorage";

export const updateNoficationState = () => {
  return dispatch =>
    dispatch({
      type: UPDATE_NOTIFICATION_STATE,
    });
};

export const getNotifications = (page = 1) => {
  return (dispatch, getState) => {
    const notifications = getState().notifications?.notificationsState?.results;

    dispatch(apiStart());
    axios
      .get(getNotificationsUrl(page))
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resData = res.data[0];

          let notification = {
            ...resData,
            total_pages: resData?.links?.total_pages,
            results:
              page > 1
                ? [...notifications, ...resData?.results]
                : resData?.results,
            total_count: resData?.count,
          };
          dispatch({ type: GET_NOTIFICATIONS_INFO, payload: notification });
          if (resData?.results.length == 0) {
            updateUserData({
              notification_count: false,
            });
          } else if (
            resData?.results &&
            resData?.results[0].unread_count !== 0
          ) {
            updateUserData({
              notification_count: true,
            });
          }
        } else {
          errorHandler(res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateNotificationsStatus = (id, status) => {
  return dispatch => {
    const statusValue = { status: status };
    dispatch(apiStart());
    axios
      .patch(updateNotificationStatusUrl(id), statusValue)
      .then(response => {
        const res = response.data;
        if (response.status === 200) {
          dispatch({
            type: UPDATE_NOTIFICATIONS_STATUS,
            payload: response.data,
          });
          if (res && res.unread_count != 0) {
            updateUserData({
              notification_count: false,
            });
          } else {
            updateUserData({
              notification_count: true,
            });
          }
        } else {
          errorHandler(res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const deleteNotification = id => {
  return dispatch => {
    dispatch(apiStart());
    axios
      .delete(deleteNotificationUrl(id))
      .then(response => {
        const res = response.data;
        if (res.status_code === 204) {
          dispatch({ type: DELETE_NOTIFICATIONS, payload: response });
          dispatch(apiSuccess());
          updateUserData({
            notification_count: false,
          });
        } else {
          errorHandler(res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const handlePCPRequests = (id, status, notificationId) => {
  return dispatch => {
    dispatch(apiStart());
    const statusValue = { status: status };
    axios
      .patch(updatePCPStatusUrl(id), statusValue)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch({ type: HANDLE_PCP_REQUEST, payload: response.data });
          dispatch(deleteNotification(notificationId));
          dispatch(apiSuccess());
          // successHandler(res.data.message[0]);
          const message =
            status.charAt(0).toUpperCase() + status.substring(1).toLowerCase();
          successHandler(`Request ${message}`);
        } else {
          errorHandler(res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const deletePatientPCPDoctor = (id, notificationId) => {
  return dispatch => {
    dispatch(apiStart());
    api
      .deletePatientPCPDoctor(id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 204) {
          dispatch(deleteNotification(notificationId));
          dispatch(apiSuccess());
          successHandler("Request Denied");
        } else {
          errorHandler(res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const clearNotifications = () => {
  return dispatch => {
    dispatch(apiStart());

    api
      .clearNotifications()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(apiSuccess());
          successHandler(`Notification cleared`);
        } else {
          dispatch(getNotifications());
          errorHandler(res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const markAsRead = () => {
  return dispatch => {
    dispatch(apiStart());
    api
      .markAsRead()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(getNotifications());
          dispatch(apiSuccess());
          updateUserData({
            notification_count: false,
          });
        } else {
          errorHandler(res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const schedulerunner = () => {
  return dispatch => {
    dispatch(apiStart(true));
    api
      .scheduleRunner()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 201) {
          successHandler(res.message[0]);
        }
        dispatch(apiSuccess())
      })
      .catch(error => {
        catchHandler(error, dispatch);
      })
    };
};

